document.addEventListener("DOMContentLoaded", function () {
    const modal = document.querySelector("#requestPriceModal");
    const openBtn = document.querySelector(".request__price-modal--btn");
    const closeBtn = document.querySelector(".request-modal-close-btn");
    const form = document.querySelector(".request_price-form");
    const successMessage = document.querySelector(".success-message");

    if (!modal || !closeBtn) {
        console.warn("Modal or close button not found.");
        return;
    }

    // Move modal to body if needed
    if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
    }

    // ✅ REAL modal open/close functions
    function openModal () {
        modal.classList.add("open");
        document.querySelector(".template-product")?.style.setProperty("overflow", "hidden");
    }

    function closeModal () {
        modal.classList.remove("open");
        document.querySelector(".template-product")?.style.setProperty("overflow", "unset");
    }

    // Attach button events (only if button exists)
    openBtn?.addEventListener("click", openModal);
    closeBtn.addEventListener("click", closeModal);

    // Close when clicking outside the modal
    document.addEventListener("click", function (event) {
        const modalContent = modal.querySelector(".modal-content");
        if (
            modal.classList.contains("open") &&
            !modalContent.contains(event.target) &&
            event.target !== openBtn
        ) {
            closeModal();
        }
    });

    // ✅ Automatically open modal on page load if URL ends with contact_posted=requestprice
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get("form_type");

    if (contactPosted === "contact") {
        openModal();
        if (form) form.classList.add("hidden");
        if (successMessage) successMessage.classList.remove("hidden");

        // Optional: Clean the URL
        if (history.replaceState) {
            const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
            history.replaceState(null, null, cleanUrl);
        }
    } else {
        if (form) form.classList.remove("hidden");
        if (successMessage) successMessage.classList.add("hidden");
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#request-price_form");
  if (!form) return;

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    // Get form values
    const productName = form.querySelector(
      'input[name="contact[product_name]"]'
    )?.value;
    const name = form.querySelector('input[name="contact[name]"]')?.value;
    const email = form.querySelector('input[name="contact[email]"]')?.value;
    const phone = form.querySelector('input[name="contact[phone]"]')?.value;

    if (typeof gtag === 'function') {
      gtag('event', 'gtm.formSubmit', {
        event_category: 'Contact Form',
        event_label: 'Request Price Form',
        form_type: 'Contact',
        value: 1
      });      
    }

    // OR if using Google Tag Manager’s dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.formSubmit',
      form_name: 'Request Price Form',
      form_type: 'Contact'
    });

    if (!window._klOnsite) {
      console.error("Klaviyo library not loaded.");
      return;
    }

    // Identify customer (optional, but recommended)
    _klOnsite.push([
      "identify",
      {
        $email: email,
        $first_name: name,
        $phone_number: phone,
        product_name: productName
      },
    ]);

    // Track custom event
    _klOnsite.push([
      "track",
      "Request-Price",
      {
        product_name: productName,
        email: email,
        first_name: name,
        phone_number: phone,
        submitted_at: new Date().toISOString(),
      },
    ]);

    form.reset();
  });
});